import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from '../../global-component';
import { Observable } from 'rxjs';
import { ClientsModel } from '../models/client.models';


const BASE_URL = GlobalComponent.BASE_API_URL;

@Injectable({ providedIn: 'root' })

/**
 * Client-service Component
 */
export class ClientService {

    constructor(private http: HttpClient) {
    }

    // Get Clients
    getClientsData(isblocked: boolean, limit: number, skip: number): Observable<ClientsModel> {
        return this.http.get<ClientsModel>(BASE_URL + GlobalComponent.vendorClientsGet + "?blocked=" + isblocked + "&orderby=DESC&skip=" + skip + "&limit=" + limit);
    }

    updateClientsProfile(guid: string, data: any): Observable<any> {
        return this.http.put(BASE_URL + `client/update-profile/${guid}`, data);
    }

    //
    clientaccessrequest(postdata: any) {
        return this.http.post<any[]>(BASE_URL + 'clientaccesses', { data: postdata });
    }

    clientaccessverification(postdata: any) {
        return this.http.post<any[]>(BASE_URL + 'clientaccess/verify', { data: postdata });
    }
}